import React from 'react';
import axios from "../../../../containers/api";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";
import {Button, Card, CardBody, Input, Row, Alert, InputGroupAddon, InputGroup, FormGroup, Label} from "reactstrap";
import {Colxx} from "../../../../components/common/CustomBootstrap";

class EditCustomer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            selectedCustomerToEdit: this.props.selectedCustomerToEdit
        }
        console.log(props)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({selectedCustomerToEdit: this.props.selectedCustomerToEdit});
        }
    }

    InquiryMeliCode = () => {
        let MeliCode  = toEnglishNumbers(this.state.selectedCustomerToEdit.meliCode); 
        this.props.showSpinner();
        axios.get('/api/v1/customers/InquiryMeliCode?melicode=' + MeliCode)
            //.then((res) => {
            //    this.props.hideSpinner();
            //    let response = res.data.data.result;
            //    if (response !== null && response.isSuccessful) {
            //        if (response.lastName !== null) {
            //            this.setState({ selectedCustomerToEdit: { ...this.state.selectedCustomerToEdit, CustomerName: response.name, CustomerFamily: response.lastName } })
            //        } else {
            //            this.setState({ selectedCustomerToEdit: { ...this.state.selectedCustomerToEdit, CustomerName: response.name   } })
            //        }
            //    } else {
            //        this.setState({ fullName: '' });
            //        this.props.showAlert('کد ملی معتبر نمی‌باشد', 'error');
            //    }
            //})
            .then(res => {
                this.props.hideSpinner();

                const response = res?.data?.data?.result;
                if (response?.isSuccessful) {

                    this.setState(prevState => ({
                        selectedCustomerToEdit: {
                            ...prevState.selectedCustomerToEdit,
                            customerName: response.name,
                            customerFamily: response.lastName ?? ''
                        }
                    }));

                } else {
                    this.setState(prev => ({
                        selectedCustomerToEdit: {
                            ...prev.selectedCustomerToEdit,
                            customerName: '',
                            customerFamily: ''
                        }
                    }));
                    this.props.showAlert('کد ملی معتبر نمی‌باشد', 'error');
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    validate = () => {
        let error = [];
        if (this.state.selectedCustomerToEdit.customerName === undefined || this.state.selectedCustomerToEdit.customerName === null || this.state.selectedCustomerToEdit.customerName.length === 0) {
            error.push('وارد كردن نام مشتری الزامی میباشد!');
        }
        if (this.state.selectedCustomerToEdit.meliCode === undefined || this.state.selectedCustomerToEdit.meliCode === null || this.state.selectedCustomerToEdit.meliCode.length === 0) {
            error.push('وارد كردن کد حقیقی/حقوقی الزامی میباشد!');
        }

        this.setState({errors: error});
        if (error.length === 0) {
            this.editCustomer();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    editCustomer = () => {
        this.props.showSpinner();
        axios.post('/api/v1/customers/UpdateCustomer', this.state.selectedCustomerToEdit)
            .then((res) => {
                this.props.hideSpinner();
                this.props.closeModal("editCustomerModal");
                this.props.showAlert(res.data.message , 'success');
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            })
    };

    selectHandleChange = (event, value, name) => {
        this.setState({[name]: value });
    };

    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody className="d-flex flex-column">
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center">
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label className="d-flex">شماره حقیقی/حقوقی</Label>
                                <InputGroup className="mb-3">
                                    <Input value={this.state.selectedCustomerToEdit.meliCode} readOnly/>
                                    <InputGroupAddon addonType="append" onClick={() => this.InquiryMeliCode()}>
                                                <span className="input-group-text">
                                                    <i className="fa fa-search" aria-hidden="true"/>
                                                </span>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>نام  مشتری</Label>
                                <Input value={this.state.selectedCustomerToEdit.customerName}
                                    onChange={(e) => this.setState({ selectedCustomerToEdit: { ...this.state.selectedCustomerToEdit, customerName: toEnglishNumbers(e.target.value)}})}/>
                            </FormGroup>

                             <FormGroup className="w-md-25 w-100 px-1">
                                <Label>فامیلی مشتری</Label>
                                <Input value={this.state.selectedCustomerToEdit.customerFamily}
                                    onChange={(e) => this.setState({ selectedCustomerToEdit: { ...this.state.selectedCustomerToEdit, customerFamily: toEnglishNumbers(e.target.value)}})}/>
                            </FormGroup>

                            
                        </div>

                        {this.state.errors.length === 0 ?
                            null
                            :
                            <div>
                                {(this.state.errors.map((error, i) => {
                                    return (
                                        <Alert color="danger" key={i}>{error}</Alert>
                                    )
                                }))}
                            </div>
                        }

                        <div className="d-flex mt-2 justify-content-center">
                            <FormGroup className="text-center">
                                <Button color="primary" className="btn-lg mx-2" onClick={this.validate}>
                                    ذخیره
                                </Button>
                            </FormGroup>
                        </div>
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default EditCustomer;